export default __webpack_public_path__ + "18.7ad55a.svg";